import React from 'react';
import {
    StyleSheet,
    View,
    TouchableOpacity,
    ScrollView,
    TouchableWithoutFeedback,
    ActivityIndicator
  } from 'react-native'
import css from './Style'
import MyText from './MyText';
import MyDatePicker from './MyDatePicker';
import MyTextInput from './MyTextInput';
import { MaterialIcons, Entypo, Feather } from '@expo/vector-icons'; 
import * as SecureStore from 'expo-secure-store';
import axios from 'axios';
import PRF from './assets/icons/PRF.svg';
import IndustrialWaste from './assets/icons/IndustrialWaste.svg';
import MySVG from './assets/MySVG';

import { connect } from 'react-redux';
import { openModal, closeModal } from './modalActions';

const Login = (props) => {

    const [type, setType] = React.useState('PRF');
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');

    const Login = async() => {
        const data = {
            email,
            password,
            uuid: await SecureStore.getItemAsync('secure_deviceid')
        };
        console.log(data);
        axios.post('/api/user/login.php', data)
        .then(async(res) => {
            props.setUser(res.data);
            await SecureStore.setItemAsync('email', email);
            await SecureStore.setItemAsync('password', password);
            if(!res.data.isVGroup){
                props.navigation.reset({
                    index: 0,
                    routes: [{ name: 'My Requests' }],
                });  
            }
            else{
                props.navigation.reset({
                    index: 0,
                    routes: [{ name: 'Manage Requests' }],
                });  
            }
        })
        .catch((err) => {
            if(err.response?.status == 401){
                props.openModal('Warning', err.response.data);
            }
            else{
                props.openModal('Warning', 'An internal error occured. Please try again later or contact us.');
            }
        })
    }

  return (
    <View style={{flex: 1, alignItems: 'center', justifyContent: 'center', marginTop: -20}}>
        <View>
            <MyText style={[css.title, css.bold]}>
                Login
            </MyText>
            <View style={{marginTop: 12}}>
                <MyTextInput
                    style={[{flexGrow: 0, flexShrink: 0, flexBasis: 232}, css.formRowInput]}
                    onChangeText={setEmail}
                    value={email}
                    inputMode='email'
                    keyboardType='email-address'
                    autoCapitalize='none'
                    autoCorrect={false}
                    placeholder='Email'
                    fancyPlaceholder={true}
                    validation='email'
                />
            </View>
            <View style={{marginTop: 12}}>
                <MyTextInput
                    style={[{flexGrow: 0, flexShrink: 0, flexBasis: 232}, css.formRowInput]}
                    onChangeText={setPassword}
                    value={password}
                    secureTextEntry={true}
                    placeholder='Password'
                    fancyPlaceholder={true}
                    autoCapitalize='none'
                    autoCorrect={false}
                />
            </View>
            <View style={{marginTop: 12, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                <TouchableOpacity onPress={() => Login()} style={{flexGrow: 0, flexShrink: 0, flexBasis: 110, marginRight: 10}}>
                    <MyText style={[css.button, css.bold]}>
                        Login
                    </MyText>
                </TouchableOpacity>
                <TouchableOpacity style={{flexGrow: 0, flexShrink: 0}}>
                    <MyText style={[css.bold, {fontSize: 8, color: '#461b6f'}]}>
                        Forgot Password?
                    </MyText>
                </TouchableOpacity>
            </View>
            <View style={{marginTop: 15, alignItems: 'center'}}>
                <TouchableOpacity onPress={() => props.navigation.navigate('Register')} style={{flexGrow: 0, flexShrink: 0}}>
                    <MyText style={[css.bold, {fontSize: 10, color: '#461b6f', borderStyle: 'dotted', borderColor: '#461b6f', borderBottomWidth: 1, paddingBottom: 3}]}>
                        Register and Join Us!
                    </MyText>
                </TouchableOpacity>
            </View>
        </View>
    </View>
  );
}

const styles = StyleSheet.create({
    filterButton: {
        marginRight: 10,
        marginBottom: 10,
        flexBasis: 125,
        flexGrow: 0,
        flexShrink: 0
    },
    text: {
        padding: 10,
    },
    row: {
        flexDirection: 'row',
    },
    header: {
        backgroundColor: '#461b6f',
    },
    headerText: {
        color: 'white'
    },
    cell: {
        paddingVertical: 5,
        paddingHorizontal: 10,
        height: 45,
        borderWidth: 1,
        borderColor: 'white',
        fontSize: 10,
        display: 'flex',
        justifyContent: 'center'
    },
    even: {
        backgroundColor: '#ececec'
    },
    odd: {
        backgroundColor: '#F6F4F9'
    }
});

const mapDispatchToProps = {
    openModal,
    closeModal,
}

export default connect(null, mapDispatchToProps)(Login)